import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

export function DepartmentForm({ errors, department, Controller, control }) {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [tempValue, setTempValue] = useState(false);
  const [password, setPassword] = useState('');
  const handleOpen = (checked) => {
    setTempValue(checked);
    setOpenConfirm(true);
  };
  const correctPassword = 'PSUIE4eimhtsj';
  const handleConfirm = (onChange) => {
    if (password === correctPassword) {
      onChange(tempValue); // ยอมให้เปลี่ยนค่า
      setOpenConfirm(false);
      setPassword('');
    } else {
      alert('รหัสผ่านไม่ถูกต้อง');
    }
  };
  const renderAccessList = () => (
    <div className="px-2">
      <div className="w-full px-1 py-1">
        <Controller
          name={'access.GOLD'}
          control={control}
          defaultValue={department ? department.access?.GOLD : false}
          rules={{ required: false }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} defaultChecked={field.value} />}
              label="จัดการซื้อ-ขาย"
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-1">
        <Controller
          name={'access.MATERIAL'}
          control={control}
          defaultValue={department ? department.access?.MATERIAL : false}
          rules={{ required: false }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} defaultChecked={field.value} />}
              label="จัดการคลัง"
            />
          )}
        />
      </div>
      {/* <div className="w-full px-1 py-1">
        <Controller
          name={'access.CUSTOMER'}
          control={control}
          defaultValue={department ? department.access?.CUSTOMER : false}
          rules={{ required: false }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} defaultChecked={field.value} />}
              label="ลูกค้าสัมพันธ์"
            />
          )}
        />
      </div> */}
      <div className="w-full px-1 py-1">
        <Controller
          name={'access.ACCOUNTING'}
          control={control}
          defaultValue={department ? department.access?.ACCOUNTING : false}
          rules={{ required: false }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} defaultChecked={field.value} />}
              label="การบัญชี"
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-1">
        <Controller
          name={'access.INFORMATION'}
          control={control}
          defaultValue={department ? department.access?.INFORMATION : false}
          rules={{ required: false }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} defaultChecked={field.value} />}
              label="ข้อมูลระบบ"
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-1">
        <Controller
          name={'access.USER'}
          control={control}
          defaultValue={department ? department.access?.USER : false}
          rules={{ required: false }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} defaultChecked={field.value} />}
              label="ผู้ดูแลระบบ"
            />
          )}
        />
      </div>
      <div className="pt-4">การตั้งค่าย่อย</div>
      <div className="w-full px-1 py-1">
        <Controller
          name={'access.OTHER.dateBuy'}
          control={control}
          defaultValue={department ? department?.access?.OTHER?.dateBuy : false}
          rules={{ required: false }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} defaultChecked={field.value} />}
              label="วันการซื้อขาย"
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-1">
        <Controller
          name={'access.OTHER.editGoldTransaction'}
          control={control}
          defaultValue={
            department ? department?.access?.OTHER?.editGoldTransaction : false
          }
          rules={{ required: false }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} defaultChecked={field.value} />}
              label="แก้ไขข้อมูลรายการซื้อ-ขาย"
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-1">
        <Controller
          name={'access.OTHER.prepareGold'}
          control={control}
          defaultValue={
            department ? department.access?.OTHER?.prepareGold : false
          }
          rules={{ required: false }}
          render={({ field }) => (
            <FormControlLabel
              control={<Checkbox {...field} defaultChecked={field.value} />}
              label="จัดการคลังเริ่มต้น"
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-1">
        <Controller
          name={'access.OTHER.cash'}
          control={control}
          defaultValue={department ? department.access?.OTHER?.cash : false}
          render={({ field }) => (
            <>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={field.value}
                    onChange={(e) => {
                      handleOpen(e.target.checked);
                    }}
                  />
                }
                label="เงินสด"
              />
              <Dialog
                open={openConfirm}
                onClose={() => setOpenConfirm(false)}
                PaperProps={{
                  sx: {
                    width: '500px', // 👈 กำหนดความกว้าง
                    maxWidth: '500px', // 👈 กันไม่ให้บีบกลับ
                    borderRadius: '12px',
                  },
                }}
              >
                <DialogTitle>ยืนยันรหัสผ่าน</DialogTitle>
                <DialogContent>
                  <TextField
                    type="password"
                    label="รหัสผ่าน"
                    value={password}
                    fullWidth
                    onChange={(e) => setPassword(e.target.value)}
                    autoFocus
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenConfirm(false)}>ยกเลิก</Button>
                  <Button
                    variant="contained"
                    onClick={() => handleConfirm(field.onChange)}
                  >
                    ยืนยัน
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          )}
        />
      </div>
    </div>
  );
  return (
    <div className="flex flex-row flex-wrap">
      <div className="w-full px-1 py-2">
        <Controller
          name={'name'}
          control={control}
          defaultValue={department ? department.name : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ชื่อแผนก"
              required
              fullWidth
              size={'small'}
              helperText={errors.name && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-2">
        <Controller
          name={'description'}
          control={control}
          defaultValue={department ? department.description : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="รายละเอียด"
              fullWidth
              size={'small'}
              multiline={true}
              helperText={errors.description && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div>{renderAccessList()}</div>
    </div>
  );
}

DepartmentForm.propTypes = {
  errors: PropTypes.shape({
    name: PropTypes.object,
    description: PropTypes.object,
  }),
  department: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
};

DepartmentForm.defaultProps = {
  department: null,
};

export default DepartmentForm;
